import React from 'react';
import { Check, ShieldCheck, Download, Printer, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const OfertaFinal: React.FC = () => {
  return <section className="py-10 px-4 bg-violet text-cream relative overflow-hidden" data-id="element-123">
      <div className="max-w-2xl mx-auto relative z-10" data-id="element-124">
        <div className="text-center mb-6" data-id="element-125">
          <span className="inline-block bg-brandred text-white font-rounded font-bold uppercase tracking-widest text-xs px-4 py-1.5 rounded-full mb-4 shadow-md" data-id="element-126">
            🔥 Oferta por tiempo limitado
          </span>
          <h2 className="font-rounded font-bold text-[2.25rem] sm:text-5xl text-cream leading-[1.02] mb-3" data-id="element-127">
            Menos pantallas.{' '}
            <span className="text-yellow" data-id="element-128">Más imaginación.</span>
          </h2>
          <p className="text-cream/85 text-base sm:text-lg font-semibold max-w-xl mx-auto leading-snug" data-id="element-129">
            Más de 50 libros Disney y 2.500 páginas listas para imprimir para
            convertir cualquier tarde aburrida en horas de diversión creativa.
          </p>
        </div>

        <div className="mb-6" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/d4RRdDi26Um4PeNDBwU8ao/colecion_completa.png" alt="Biblioteca Mágica Disney" className="w-full h-auto max-w-md mx-auto drop-shadow-2xl" data-id="element-131" />
        </div>

        <div className="bg-cream text-violet p-6 sm:p-8 rounded-3xl shadow-2xl border-4 border-yellow relative" data-id="element-132">
          <div className="flex justify-center gap-0.5 mb-3" data-id="element-133">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-dark text-gold-dark" data-id="element-134" />)}
          </div>

          <div className="text-center mb-5" data-id="element-135">
            <p className="text-sm text-textsoft font-bold uppercase tracking-wider mb-2" data-id="element-136">
              Precio especial hoy
            </p>
            <div className="flex flex-col items-center gap-1" data-id="element-137">
              <div className="flex items-baseline gap-2" data-id="element-138">
                <span className="text-xs uppercase tracking-wider text-textsoft font-bold" data-id="element-139">
                  Valor real:
                </span>
                <span className="text-gray-400 line-through text-xl font-bold" data-id="element-140">
                  $89.990
                </span>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-141">
                <span className="text-sm uppercase tracking-wider text-violet font-extrabold" data-id="element-142">
                  Hoy:
                </span>
                <span className="font-rounded font-bold text-5xl sm:text-6xl text-violet leading-none" data-id="element-143">
                  $19.990
                </span>
              </div>
            </div>
            <p className="text-sm font-extrabold text-brandgreen mt-2" data-id="element-144">
              🎉 Ahorrás $70.000
            </p>
          </div>

          <ul className="space-y-2 mb-6 max-w-xs mx-auto" data-id="element-145">
            {['Acceso inmediato', 'Descarga digital', 'Más de 50 libros', 'Más de 2.500 páginas', 'Listo para imprimir', 'Impresión ilimitada'].map((item, idx) => <li key={idx} className="flex items-center gap-2.5 text-violet font-bold text-base" data-id="element-146">
                <div className="bg-brandgreen rounded-full p-0.5 flex-shrink-0" data-id="element-147">
                  <Check className="text-white w-3.5 h-3.5" strokeWidth={3.5} data-id="element-148" />
                </div>
                <span data-id="element-149">{item}</span>
              </li>)}
          </ul>

          <CTAButton size="large" subtext="Acceso inmediato · Pago seguro · Impresión ilimitada" data-id="element-150" />

          <div className="flex flex-wrap justify-center gap-4 mt-5 pt-5 border-t-2 border-dashed border-cream-dark text-xs sm:text-sm font-bold text-textsoft" data-id="element-151">
            <div className="flex items-center gap-1.5" data-id="element-152">
              <ShieldCheck className="w-4 h-4 text-brandgreen" data-id="element-153" />
              <span data-id="element-154">Compra segura</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-155">
              <Download className="w-4 h-4 text-violet" data-id="element-156" />
              <span data-id="element-157">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-158">
              <Printer className="w-4 h-4 text-violet" data-id="element-159" />
              <span data-id="element-160">Imprime sin límites</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};